
import { AllTag, CategoryTag, SearchTerms, TagSink } from 'indexing'

import RemoveSearchProfile from './remove_search_profile'
import Summaries from './summaries'
import renderPill from './templates/pill'

export default ($context = document) => {
  $(() => {
    const eventNameSpace = 'search-profile-tag'

    $('.js-search-profile__reset-tags', $context).on('click', function (event) {
      event.preventDefault()
      EventBus.trigger('search-profile-tag:reset', null)
    })

    $('.js-search-profile__accordion-title', $context).on('click', function (event) {
      const id = $(this).attr('for')
      const $target = $(`#${id}`)
      if ($target.prop('checked')) {
        event.preventDefault()
        $target.prop('checked', false)
      }
    })

    $('.js-search-profile__tags-container', $context).map(function () {
      new TagSink($(this), renderPill, '.js-tag-sink__pill', '.js-search-input__remove', eventNameSpace)
    })

    $('.js-search-profile__tag-checkbox-all', $context).map(function () {
      new AllTag($(this), '.js-search-profile__tag-checkbox', eventNameSpace)
    })

    $('.js-search-profile__tag-checkbox', $context).map(function () {
      new CategoryTag($(this), eventNameSpace)
    })

    $('.js-search-profile-summary', $context).map(function () {
      new RemoveSearchProfile($(this))
    })

    $('.js-search-profile-summaries', $context).map(function () {
      new Summaries($(this))
    })

    $('.js-search-term', $context).map(function () {
      new SearchTerms($(this), '.js-search-term', eventNameSpace)
    })
  })
}
